import type { ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useLocation } from 'react-router';
import PageErrorFallback from './PageErrorFallback';

type TPageErrorBoundaryProps = {
	children: ReactNode;
};

const PageErrorBoundary = ({ children }: TPageErrorBoundaryProps) => {
	const { pathname } = useLocation();

	return (
		<ErrorBoundary FallbackComponent={PageErrorFallback} resetKeys={[pathname]}>
			{children}
		</ErrorBoundary>
	);
};

export default PageErrorBoundary;
